/** 一行可容纳的全角字数。半角字符（英文、数字、半角标点）按 0.5 计。 */
const LINE_UNITS = 8;
const PREVIEW_LINES = 2;

function isFullWidth(code: number): boolean {
  return (
    (code >= 0x1100 && code <= 0x115f) ||
    (code >= 0x2329 && code <= 0x232a) ||
    (code >= 0x2e80 && code <= 0xa4cf) ||
    (code >= 0xac00 && code <= 0xd7a3) ||
    (code >= 0xf900 && code <= 0xfaff) ||
    (code >= 0xfe10 && code <= 0xfe19) ||
    (code >= 0xfe30 && code <= 0xfe6f) ||
    (code >= 0xff00 && code <= 0xff60) ||
    (code >= 0xffe0 && code <= 0xffe6) ||
    (code >= 0x1f200 && code <= 0x1f251) ||
    (code >= 0x20000 && code <= 0x3fffd)
  );
}

/** 全角（汉字、全角标点）占 1，其余按半角占 0.5，使英文在字宽处断开而不是按单词断开。 */
function charUnits(ch: string): number {
  const code = ch.codePointAt(0) ?? 0;
  if (isFullWidth(code)) return 1;
  return 0.5;
}

/**
 * 收起态只展示前两行。
 * caretMap[previewCaret] 是原文中的 UTF-16 下标，供点进编辑时还原光标。
 */
export function buildSlotSummaryPreview(text: string): { preview: string; caretMap: number[] } {
  const source = text.replace(/\r\n/g, '\n');
  let preview = '';
  const caretMap: number[] = [];
  let units = 0;
  let lines = 1;
  let sourceIndex = 0;

  const finish = () => {
    caretMap.push(sourceIndex);
    return { preview, caretMap };
  };

  for (const ch of Array.from(source)) {
    if (ch === '\n') {
      if (lines >= PREVIEW_LINES) return finish();
      caretMap.push(sourceIndex);
      preview += '\n';
      sourceIndex += 1;
      lines += 1;
      units = 0;
      continue;
    }
    const w = charUnits(ch);
    if (units > 0 && units + w > LINE_UNITS) {
      if (lines >= PREVIEW_LINES) return finish();
      caretMap.push(sourceIndex);
      preview += '\n';
      lines += 1;
      units = 0;
    }
    caretMap.push(sourceIndex);
    preview += ch;
    sourceIndex += ch.length;
    units += w;
  }
  return finish();
}
